export default function FaqHero() {
  return (
    <section className="w-full bg-white pt-24 pb-0 border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="py-12 flex flex-col md:flex-row md:items-center gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <span
                className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                FAQ
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-4">
              자주 묻는{' '}
              <span style={{ color: '#2E7D6B' }}>질문</span>
            </h1>
            <div
              className="rounded-xl px-5 py-4 text-sm leading-relaxed mb-5"
              style={{ backgroundColor: '#f0f9f6', borderLeft: '4px solid #2E7D6B' }}
            >
              <p className="text-gray-700">
                간병보험 청구, 간병인 등록, 서류 안내 등 고객님들이 가장 많이 물어보시는
                질문들을 모았습니다. 원하시는 답변을 빠르게 찾아보세요.
              </p>
            </div>
            <div className="flex flex-wrap gap-2">
              {['보험 청구', '간병인 등록', '서류 안내', '비용 안내', '기타 문의'].map((tag) => (
                <a
                  key={tag}
                  href={`#${tag}`}
                  className="text-xs font-medium px-3 py-1.5 rounded-full border cursor-pointer transition-colors hover:border-[#2E7D6B] hover:text-[#2E7D6B]"
                  style={{ borderColor: '#e5e7eb', color: '#6b7280' }}
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-center">
            <div
              className="w-36 h-36 md:w-44 md:h-44 rounded-2xl flex flex-col items-center justify-center gap-2"
              style={{ backgroundColor: '#f0f9f6', border: '2px solid rgba(46,125,107,0.2)' }}
            >
              <i className="ri-question-answer-line text-5xl md:text-6xl" style={{ color: '#2E7D6B' }}></i>
              <span className="text-xs font-bold text-gray-600 text-center leading-tight px-2">자주 묻는<br/>질문 모음</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
